// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__oViZY","header":"ClearentDisclaimer_header__2X0jc","inner":"ClearentDisclaimer_inner__2czmn"};